<template>
  <v-container fluid>
    <RequestInCar v-model="currentRequest" />
    <v-row dense>
      <v-col
        v-if="$currentUser.anyCargoType"
        cols="3"
        class="pb-0"
      >
        <CargoTypeSelector
          v-model="cargoTypeID"
          dense
          :can-any="true"
          @input="onCargoTypeSelectorChanged"
        />
      </v-col>
    </v-row>

    <UsedCellsCount :cargo-type-id="cargoTypeID" />

    <v-card-text class="py-0 text-subtitle-1">
      Машины с заявками [ {{ carsWithRequests.length }} шт. ]
    </v-card-text>
    <v-data-table
      dense
      :items="carsWithRequests"
      :headers="carsAndRequests.headers"
      :loading="carsAndRequests.loading"
      :hide-default-header="hideHeader"
      hide-default-footer
      disable-pagination
      disable-filtering
      disable-sort
      show-expand
      :expanded="carsAndRequests.expanded"
      :items-per-page="itemsPerPage"
      item-key="id"
      loading-text="Загрузка данных..."
      no-data-text="Нет машин с заявками..."
      class="styled-table pointed-table"
      :item-class="requestsWithCars_rowClasses"
      @click:row="toggleExpanded"
    >
      <!-- expand column -->
      <template v-slot:[`item.data-table-expand`]="{isExpanded, expand}">
        <v-icon
          v-if="!isExpanded"
          @click="expand(true)"
        >
          mdi-chevron-down
        </v-icon>
        <v-icon
          v-if="isExpanded"
          @click="expand(false)"
        >
          mdi-chevron-up
        </v-icon>
      </template>

      <template v-slot:expanded-item="{headers, item}">
        <td
          :colspan="headers.length"
          class="px-0"
        >
          <!-- подтаблица -->
          <v-data-table
            dense
            hide-default-header
            hide-default-footer
            item-key="id"
            :items="item.requests"
            class="pointed-table"
          >
            <template v-slot:item="props">
              <tr @click="openRequestDialog(props.item)">
                <td>
                  <v-col class="py-1 pl-14 d-flex flex-row align-center">
                    <span class="mr-2">№</span>
                    <span class="accent--text">{{ props.item.number }}</span>
                    <span class="mx-2"> от </span>
                    <span class="accent--text">{{ props.item.date | dateFormat }}</span>
                    <span class="ml-2 mr-8">{{ props.item.requestStatusName }}</span>
                    <v-spacer />
                    <span class="grey--text">ID: {{ props.item.id }}</span>
                  </v-col>
                </td>
              </tr>
            </template>
          </v-data-table>
        </td>
      </template>

      <template v-slot:[`item.driver`]="{item}">
        {{ item.driver | shortName }}
      </template>

      <template v-slot:[`item.createTimeStamp`]="{item}">
        {{ item.createTimeStamp | dateTimeFormat }}
      </template>

      <template v-slot:[`item.carTimeIn`]="{item}">
        {{ item.carTimeIn | dateTimeFormat }}
      </template>

      <template v-slot:[`item.carNumber`]="{item}">
        {{ item.carCountryName }} {{ item.carNumber }}
      </template>
    </v-data-table>

    <v-card-text class="pb-0 text-subtitle-1">
      Машины без заявок [ {{ carsWithoutRequests.length }} шт. ]
    </v-card-text>
    <v-data-table
      dense
      :items="carsWithoutRequests"
      :headers="carsAndRequests.headers"
      :loading="carsAndRequests.loading"
      :hide-default-header="hideHeader"
      hide-default-footer
      disable-pagination
      disable-filtering
      disable-sort
      :items-per-page="itemsPerPage"
      item-key="id"
      loading-text="Загрузка данных..."
      no-data-text="Нет машин без заявок..."
      no-results-text="Совпадений не найдено..."
      class="styled-table"
    >
      <template v-slot:[`item.driver`]="{item}">
        {{ item.driver | shortName }}
      </template>

      <template v-slot:[`item.createTimeStamp`]="{item}">
        {{ item.createTimeStamp | dateTimeFormat }}
      </template>

      <template v-slot:[`item.carTimeIn`]="{item}">
        {{ item.carTimeIn | dateTimeFormat }}
      </template>

      <template v-slot:[`item.carNumber`]="{item}">
        {{ item.carCountryName }} {{ item.carNumber }}
      </template>
    </v-data-table>

    <v-card-text class="pb-0 text-subtitle-1">
      Заявки без машин [ {{ requestsWithoutCars.items.length }} шт. ]
    </v-card-text>
    <v-data-table
      :items="requestsWithoutCars.items"
      :headers="requestsWithoutCars.headers"
      :loading="requestsWithoutCars.loading"
      :hide-default-header="hideHeader"
      :items-per-page="itemsPerPage"
      dense
      hide-default-footer
      disable-pagination
      disable-filtering
      disable-sort
      item-key="id"
      loading-text="Загрузка данных..."
      no-data-text="Нет заявок без машин..."
      no-results-text="Совпадений не найдено..."
      class="styled-table pointed-table"
      :item-class="requestsWithoutCars_rowClasses"
      @click:row="openRequestDialog"
    >
      <template v-slot:[`item.driver`]="{item}">
        {{ item.driver | shortName }}
      </template>

      <template v-slot:[`item.car`]="{item}">
        {{ item.car | onlyCarNumber }}
      </template>

      <template v-slot:[`item.date`]="{item}">
        {{ item.date | dateFormat }}
      </template>

      <template v-slot:[`item.requestStatusName`]="{item}">
        <div
          v-if="item.requestStatusID === -10"
          class="error--text"
        >
          <v-tooltip
            top
            nudge-top="4"
          >
            <template v-slot:activator="{on, attrs}">
              <span
                v-bind="attrs"
                v-on="on"
              >Ошибка</span>
            </template>
            <span>{{ item.error }}</span>
          </v-tooltip>
        </div>
        <span v-else>
          {{ item.requestStatusName }}
        </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import CargoTypeSelector from "@/components/CargoTypeSelector"
import saveState from "@/utils/saveState"
import RequestInCar from "./RequestInCar"
import UsedCellsCount from "./UsedCellsCount"

export default {
  components: {
    CargoTypeSelector,
    RequestInCar,
    UsedCellsCount
  },

  mixins: [saveState],
  data: () => ({
    itemsPerPage: Number.MAX_SAFE_INTEGER,
    cargoTypeID: 0, // любой
    // показываем заявку
    currentRequest: null,

    // заявки без машин
    requestsWithoutCars: {
      items: [],
      loading: true,
      headers: [
        {
          text: "",
          value: "data-table-expand",
          width: "56px",
          class: "tableHeader tableHeaderText--text",
          sortable: false
        },
        { text: "Тип заявки", value: "requestTypeName", class: "tableHeader tableHeaderText--text" },
        { text: "№ заявки", value: "number", class: "tableHeader tableHeaderText--text" },
        { text: "Дата", value: "date", class: "tableHeader tableHeaderText--text" },
        { text: "№ машины", value: "car", class: "tableHeader tableHeaderText--text" },
        { text: "Водитель", value: "driver", class: "tableHeader tableHeaderText--text" },
        { text: "Статус", value: "requestStatusName", class: "tableHeader tableHeaderText--text" }
      ]
    },

    // машины и заявки
    carsAndRequests: {
      expanded: [],
      items: [],
      loading: true,
      headers: [
        {
          text: "",
          value: "data-table-expand",
          width: "56px",
          class: "tableHeader tableHeaderText--text",
          sortable: false
        },
        { text: "Операция", value: "carOperationTypeName", class: "tableHeader tableHeaderText--text" },
        { text: "№ машины", value: "carNumber", class: "tableHeader tableHeaderText--text" },
        { text: "Водитель", value: "driver", class: "tableHeader tableHeaderText--text" },
        { text: "Тел. водителя", value: "driverPhone", class: "tableHeader tableHeaderText--text" },
        { text: "Регистрация", value: "createTimeStamp", class: "tableHeader tableHeaderText--text" },
        { text: "Въезд", value: "carTimeIn", class: "tableHeader tableHeaderText--text" },
        { text: "Статус", value: "carStatusName", class: "tableHeader tableHeaderText--text" }
      ]
    }
  }),

  computed: {
    hideHeader: function () {
      return this.$vuetify.breakpoint.xsOnly
    },

    carsWithoutRequests: function () {
    return (this.carsAndRequests.items || [])
      .filter((c) => !Array.isArray(c.requests) || !c.requests.length)
  },

    carsWithRequests: function () {
    return (this.carsAndRequests.items || [])
      .filter((c) => Array.isArray(c.requests) && c.requests.length)
  }
  },

  created() {
    // столбец с типом груза только для тех, кто видит разные
    if (this.$currentUser.anyCargoType) {
      this.carsAndRequests.headers.splice(1, 0, {
        text: "Тип груза",
        value: "cargoTypeName",
        class: "tableHeader tableHeaderText--text"
      })
      this.requestsWithoutCars.headers.splice(1, 0, {
        text: "Тип груза",
        value: "cargoTypeName",
        class: "tableHeader tableHeaderText--text"
      })
    }

    this.loadRequestsWithoutCars()
    this.loadCarsAndRequests()

    // Сигналы
    this.$signals.on("CarNotify", this.onCarNotify)

    this.$signals.on("CarQueue_Delete", this.onCarQueueDelete)
    this.$signals.on("CarQueue_Insert", this.onCarQueueInsert)
    this.$signals.on("CarQueue_Update", this.onCarQueueUpdate)
    this.$signals.on("CarQueue_UpdateTimeAndStatus", this.onCarQueueUpdateTimeAndStatus)
    this.$signals.on("Request_Insert", this.onRequestInsert)
    this.$signals.on("Request_Update", this.onRequestUpdate)
    this.$signals.on("Request_Delete", this.onRequestDelete)
    this.$signals.on("Request_UpdateStatus", this.onRequestUpdateStatus)
  },

  beforeDestroy() {
    this.$signals.off("CarNotify", this.onCarNotify)

    this.$signals.off("CarQueue_Delete", this.onCarQueueDelete)
    this.$signals.off("CarQueue_Insert", this.onCarQueueInsert)
    this.$signals.off("CarQueue_Update", this.onCarQueueUpdate)
    this.$signals.off("CarQueue_UpdateTimeAndStatus", this.onCarQueueUpdateTimeAndStatus)
    this.$signals.off("Request_Insert", this.onRequestInsert)
    this.$signals.off("Request_Update", this.onRequestUpdate)
    this.$signals.off("Request_Delete", this.onRequestDelete)
    this.$signals.off("Request_UpdateStatus", this.onRequestUpdateStatus)
  },

  methods: {
    requestsWithoutCars_rowClasses(item) {
      if (item.highlight) return "highlightRequest--text" //can also return multiple classes e.g ["orange","disabled"]
    },

    requestsWithCars_rowClasses(item) {
      if (item.requests.some((r) => r.highlight)) return "highlightRequest--text"
    },

    isCargoTypeValid(cargoTypeID) {
      // пользователь не должен видеть машины и заявки других клиентов
      return this.$currentUser.anyCargoType || this.$currentUser.cargoTypeID === cargoTypeID
    },

    openRequestDialog(request) {
      this.currentRequest = request
    },

    toggleExpanded(value) {
      const x = this.carsAndRequests.expanded.pop()
      if (x !== value) {
        this.carsAndRequests.expanded.push(value)
      }
    },

    async loadRequestsWithoutCars() {
      this.requestsWithoutCars.loading = true
      await this.axios
        .get("/carRequests/requestsWithoutCars", {
          params: {
            cargoTypeID: this.cargoTypeID
          }
        })
        .then((response) => {
          this.requestsWithoutCars.items = response.data
          this.requestsWithoutCars.loading = false
        })
        .catch((err) => {
          this.$router.push(`/error?message=Ошибка при получении списка заявок&&error=${err}`)
        })
    },

    async loadCarsAndRequests() {
      this.carsAndRequests.loading = true
      await this.axios
        .get("/carRequests/carsAndRequests", {
          params: {
            cargoTypeID: this.cargoTypeID
          }
        })
        .then((response) => {
          this.carsAndRequests.items = response.data
          this.sortCarsAndRequests()
          this.carsAndRequests.loading = false
        })
        .catch((err) => {
          this.$router.push(`/error?message=Ошибка при получении списка машин&&error=${err}`)
        })
    },

    saveStateConfig() {
      return {
        saveKey: "carRequests",
        saveProperties: ["cargoTypeID"]
      }
    },

    onCargoTypeSelectorChanged() {
      this.loadCarsAndRequests()
      this.loadRequestsWithoutCars()
    },

    onCarNotify(message, cargoTypeID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      this.$notify("info", message)
    },

    // удаление регистрации машины
    onCarQueueDelete(id) {
      // удалить машину из списков, заявки разбиндятся отдельными сигналами
      const index = this.carsAndRequests.items.findIndex((x) => x.id === id)
      if (index !== -1) {
        this.carsAndRequests.items.splice(index, 1)
      }
    },

    onCarQueueInsert(id, cargoTypeID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      // запросить список машин с сервера,
      // пройти массив map, вставить элемент
      // хер так просто сделать, так как сортировка на сервере
      this.loadCarsAndRequests()
    },

    onCarQueueUpdate(id, cargoTypeID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      // запросить список машин с сервера,
      // пройти массив map, заменить элемент
      // если сделать на серваке отдельный контроллер на get(id), то реализуемо, но лень,
      // так что тяну весь массив => не имеет смысла не обновить его весь
      this.loadCarsAndRequests()
    },

    // обновление времени въезда/выезда машины и её статуса
    onCarQueueUpdateTimeAndStatus(id, cargoTypeID, newCarStatusID, carTimeIn) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      const carIndex = this.carsAndRequests.items.findIndex((c) => c.id === id)
      if (carIndex >= 0) {
        // если статус Обработано, то удаляем из списка
        if (newCarStatusID === 100) {
          this.carsAndRequests.items.splice(carIndex, 1)
        } else {
          // иначе будем менять ей время и статус
          const car = this.carsAndRequests.items[carIndex]
          car.carStatusID = newCarStatusID
          car.carStatusName = this.$store.getters["directories/getCarStatus"](newCarStatusID).name
          if (carTimeIn) {
            car.carTimeIn = carTimeIn
          }
          this.sortCarsAndRequests()
        }
      }
    },

    onRequestInsert(id, cargoTypeID, carQueueID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      // TODO: некогда добавляется заявка... надо запросить с сервера и если с машиной, то добавить в машину, если без, то в без,
      // что сложнее из-за сортировки, но реализуемо
      if (!carQueueID) {
        this.loadRequestsWithoutCars()
        return
      }
      this.loadCarsAndRequests()
    },

    onRequestUpdate(id, cargoTypeID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      // запрос заявки с сервера
      // если заявка забиндина на машину и машина есть - найти машину, обновить заявку, если машины нет - ПИЗДА
      // если не забиндина - найти в списке заявок без машин и обновить
      this.loadCarsAndRequests()
      this.loadRequestsWithoutCars()
    },

    onRequestDelete(id, cargoTypeID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      // если заявка не была привязана к машине - просто удаляем из списка
      const index = this.requestsWithoutCars.items.findIndex((x) => x.id === id)
      if (index !== -1) {
        this.requestsWithoutCars.items.splice(index, 1)
        return
      }
      // ищем заявку в машинах
      const carWithRequest = this.carsAndRequests.items.find((c) => c.requests.findIndex((r) => r.id === id) >= 0)
      if (carWithRequest) {
        const requestIndex = carWithRequest.requests.findIndex((r) => r.id === id)
        carWithRequest.requests.splice(requestIndex, 1)
      }
    },

    onRequestUpdateStatus(id, cargoTypeID, requestStatusID) {
      // кому не надо видеть - не обрабатываем
      if (!this.isCargoTypeValid(cargoTypeID)) return

      // обработана или загружена сюда прийти не может, так что просто обновляю статус
      // если заявка не привязана к машине
      const request = this.requestsWithoutCars.items.find((x) => x.id === id)
      if (request) {
        request.requestStatusID = requestStatusID
        request.requestStatusName = this.$store.getters["directories/getRequestStatus"](requestStatusID).name
        return
      }
      // ищем заявку в машинах
      const carWithRequest = this.carsAndRequests.items.find((c) => c.requests.findIndex((r) => r.id === id) >= 0)
      if (carWithRequest) {
        const requestInCar = carWithRequest.requests.find((r) => r.id === id)
        if (requestInCar) {
          requestInCar.requestStatusID = requestStatusID
          requestInCar.requestStatusName = this.$store.getters["directories/getRequestStatus"](requestStatusID).name
          this.sortCarsAndRequests()
        }
      }
    },

    // сортировка машин по очереди
    sortCarsAndRequests() {
      this.carsAndRequests.items.sort(function (a, b) {
        // сначала по статусу
        if (a.carStatusID != b.carStatusID) return b.carStatusID - a.carStatusID
        // потом по времени
        if (a.createTimeStamp > b.createTimeStamp) return 1
        if (a.createTimeStamp < b.createTimeStamp) return -1
        // равно => тогда по id
        return a.id - b.id
      })
    }
  }
}
</script>
